import Axios from 'axios';

const Request = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export default Request;
